import { Button } from '@material-ui/core';
import clsx from 'clsx';
import { FC } from 'react';
import { PrestationFields, ResourceSections, WizardLayout } from '../shared/components';
import StepEmail from './components/StepEmail';
import StepInfos from './components/StepInfos';
import { TOTAL_STEPS } from './constants';
import { useStyles } from './styles';
import { useCreateBeneficiaryWizard } from './useCreateBeneficiaryWizard';

const CreateBeneficiary: FC = () => {
  const classes = useStyles();
  const wizard = useCreateBeneficiaryWizard();

  const nextDisabled =
    wizard.submitting ||
    (wizard.step === 1 &&
      (!wizard.isEmailValid || Boolean(wizard.existingUser) || wizard.checkingEmail)) ||
    (wizard.step === 2 && !wizard.canGoInfos) ||
    (wizard.step === 3 && !wizard.canGoResources);

  return (
    <WizardLayout
      classes={classes}
      backLabel="← Retour aux bénéficiaires"
      onBack={wizard.goBack}
      title="Créer un compte bénéficiaire"
      step={wizard.step}
      totalSteps={TOTAL_STEPS}
      bodyClassName={wizard.step === 4 ? classes.bodyWide : classes.body}
      footerClassName={clsx(
        classes.footer,
        wizard.step === 1 && !wizard.existingUser && classes.footerEnd
      )}
      footer={
        <>
          {wizard.step > 1 && (
            <Button className={classes.secondaryBtn} onClick={wizard.goPrevious}>
              ← Précédent
            </Button>
          )}
          {wizard.step < 4 && !wizard.existingUser && (
            <Button className={classes.primaryBtn} disabled={nextDisabled} onClick={wizard.goNext}>
              Suivant →
            </Button>
          )}
          {wizard.step === 4 && (
            <Button
              className={classes.primaryBtn}
              disabled={wizard.submitting}
              onClick={wizard.handleSubmit}>
              {wizard.submitting ? 'Enregistrement...' : 'Enregistrer'}
            </Button>
          )}
        </>
      }>
      {wizard.step === 1 && (
        <StepEmail
          email={wizard.email}
          existingUser={wizard.existingUser}
          existingPrestations={wizard.existingPrestations}
          checkingEmail={wizard.checkingEmail}
          onEmailChange={wizard.handleEmailChange}
          onAddPrestation={wizard.openExistingUserProfile}
        />
      )}
      {wizard.step === 2 && <StepInfos infos={wizard.infos} onChange={wizard.updateInfos} />}
      {wizard.step === 3 && (
        <PrestationFields
          consultants={wizard.consultants}
          consultantId={wizard.consultantId}
          lockConsultant={wizard.isConsultant}
          onConsultantChange={wizard.setConsultantId}
          services={wizard.availableServices}
          serviceId={wizard.serviceId}
          onServiceChange={wizard.setServiceId}
          infoBox="Lors de la création, vous pouvez attribuer une seule prestation au bénéficiaire. Pour ajouter d'autres prestations, rendez-vous sur la page d'édition du bénéficiaire, onglet 'Prestations'"
        />
      )}
      {wizard.step === 4 && (
        <ResourceSections
          loading={wizard.loadingCatalogs}
          heading="Ressources de la prestation"
          emptyHint="Aucune ressource liée à cette prestation."
          sections={[
            {
              kind: 'majorTests',
              catalog: wizard.majorCatalog,
              selected: wizard.majorTests,
            },
            {
              kind: 'minorTests',
              catalog: wizard.minorCatalog,
              selected: wizard.minorTests,
            },
            {
              kind: 'games',
              catalog: wizard.gameCatalog,
              selected: wizard.games,
            },
            {
              kind: 'books',
              catalog: wizard.bookCatalog,
              selected: wizard.books,
            },
            {
              kind: 'ebooks',
              catalog: wizard.ebookCatalog,
              selected: wizard.ebooks,
            },
          ]}
          onToggle={wizard.toggleResource}
          onRemove={wizard.removeResource}
        />
      )}
    </WizardLayout>
  );
};

export default CreateBeneficiary;
